import React, { Component } from 'react';
import { connect } from 'react-redux';
import EditarCliente from './EditarCliente';
import { fetchClientesPedidos, clearClientes } from '../../../../../actions';
import Alert from '../../../../../components/Alert';

class ClienteCard extends Component {
  constructor(props) {
    super(props);

    const pedidosCard = [];

    if (this.props.indice === 0) {
      this.props.pedidos.map(({ numPedidoVeh }) => pedidosCard.push(numPedidoVeh));
    }

    this.state = {
      editIsOpen: false,
    };
  }

  saveClient = (cliente, tipoCliente, index) => {
    this.props.selectClient(cliente, tipoCliente, index);
    this.setState({ editIsOpen: false });
  }

  selectPedido = (pedido, tipoCliente, index) => {
    this.props.selectPedido(pedido, tipoCliente, index);
    this.forceUpdate();
  }

  unselectPedido = (pedido, tipoCliente, index) => {
    this.props.unselectPedido(pedido, tipoCliente, index);
    this.forceUpdate();
  }

  toggleEdit = () => this.setState({ editIsOpen: !this.state.editIsOpen })

  render() {
    return (
      <div className='card card-lg card-plain mb-2'>
        <p className='labelInfo'>{this.props.name}</p>
        <div className='cd-cont'>
          <div className='row'>
            <div className='col-md-10'>
              <p>{this.props.tipo.id} - {this.props.tipo.nombre}</p>
            </div>
            <div className='col-md-2'>
              <button className='btn-clean' onClick={this.toggleEdit}>
                <i className='ion-edit c-cyan h6 mr-2' />
              </button>
              {
                this.props.indice > 0 &&
                <button className='btn-clean h6 c-cyan' onClick={() => this.props.removeCard(this.props.tipoCliente, this.props.indice)}>
                  <i className='ion-trash-a' />
                </button>
              }
            </div>
            {
              this.props.indice === 0 &&
                <div className='col-xs-12'>
                  <div className='radio'>
                    <label className='radio-label' htmlFor={`${this.props.tipoCliente}-all`}>
                      <input type='radio' name={`${this.props.tipoCliente}Pedidos`} id={`${this.props.tipoCliente}-all`} checked={this.props.todo === 'si'} value='si' onChange={e => this.props.onChangeCheck(e, this.props.tipoCliente)} />
                      <div className='radio-skin' />Aplicar a todos los pedidos</label>
                  </div>
                  <div className='radio'>
                    <label className='radio-label' htmlFor={`${this.props.tipoCliente}-select`}>
                      <input type='radio' name={`${this.props.tipoCliente}Pedidos`} id={`${this.props.tipoCliente}-select`} checked={this.props.todo === 'no'} value='no' onChange={e => this.props.onChangeCheck(e, this.props.tipoCliente)} />
                      <div className='radio-skin' />Aplicar a los pedidos seleccionados</label>
                  </div>
                </div>
            }
          </div>
          {
            this.props.todo === 'no' &&
              <div className='row js-open'>
                <div className='col-sm-6'>
                  <div className='dropdown dropdown-multi customToggle'>
                    <div className='dropdown-control'>
                      <input className='dropdown-control-input' />
                      <label className='dropdown-control-fakelabel'><span /><span className='dropdown-control-count' /></label>
                      <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
                    </div>
                    <div className='dropdown-tooltip dropdown-menu'>
                      <div className='dropdown-scroll'>
                        <p />
                        <ul>
                          {
                            this.props.pedidos.map(({ numPedidoVeh }) => (
                              <li key={numPedidoVeh}>
                                <div className='checkbox'>
                                  <label htmlFor={`${numPedidoVeh}-${this.props.tipoCliente}-${this.props.indice}`}>
                                    <input type='checkbox' id={`${numPedidoVeh}-${this.props.tipoCliente}-${this.props.indice}`} checked={this.props.tipo.pedidos.indexOf(numPedidoVeh)>=0} onChange={() => this.selectPedido(numPedidoVeh, this.props.tipoCliente, this.props.indice)} />
                                    <div className='checkbox-skin' />{numPedidoVeh}</label>
                                </div>
                              </li>
                            ))
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='pillSelct mb-3'>
                    <ul className='pillSelct-pills'>
                      {this.props.tipo.pedidos.map(pedido => (
                        <li className='pillSelct-pills-item pill pill-cyan' key={pedido}>
                          {pedido}
                          <button className='pillSelct-delete' onClick={() => this.unselectPedido(pedido, this.props.tipoCliente, this.props.indice)}>
                            <i className='icon ion-close pill-close' />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
          }
        </div>
        <EditarCliente
          saveClient={this.saveClient}
          tipoCliente={this.props.tipoCliente}
          isOpen={this.state.editIsOpen}
          fetchClientes={this.props.fetchClientesPedidos}
          clearClientes={this.props.clearClientes}
          clientes={this.props.clientes}
          indice={this.props.indice}
        />

        {
          this.props.clientes && this.props.clientes.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar clientes</p>
            </Alert> : null
        }


      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientes: state.clientes,
  };
}

export default connect(mapStateToProps, { fetchClientesPedidos, clearClientes })(ClienteCard);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/AsociarPedidos/ClienteCard.js